export default "__VITE_PUBLIC_ASSET__22a9941f__"